export { getTickValues, getNiceTickValues, getTickValuesFixedDomain } from './getNiceTickValues';


//////////////////
// WEBPACK FOOTER
// ./node_modules/recharts-scale/es6/index.js
// module id = 1240
// module chunks = 1